module.exports = __webpack_public_path__ + "img/6-3.a80c51e2.png";